(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-featured-carousel-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(section) {
      if (section.dataset.fbfcv3Init === 'true') return;
      section.dataset.fbfcv3Init = 'true';

      if ('IntersectionObserver' in window) {
        var animObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('fb-visible');
              animObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        section.querySelectorAll('.fb-anim-eyebrow, .fb-anim-title, .fb-anim-sub, .fb-anim-card, .fb-anim-cta')
          .forEach(function (el) { animObserver.observe(el); });
      } else {
        section.querySelectorAll('.fb-anim-eyebrow, .fb-anim-title, .fb-anim-sub, .fb-anim-card, .fb-anim-cta')
          .forEach(function (el) { el.classList.add('fb-visible'); });
      }

      var viewport = section.querySelector('.fbfcv3__viewport');
      var track = section.querySelector('.fbfcv3__track');
      var slides = Array.prototype.slice.call(section.querySelectorAll('.fbfcv3__slide'));
      var prevBtn = section.querySelector('.fbfcv3__arrow--prev');
      var nextBtn = section.querySelector('.fbfcv3__arrow--next');
      var dotsWrap = section.querySelector('.fbfcv3__dots');
      var wantsAutoplay = section.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '4000', 10);
      if (!viewport || !track || !slides.length) return;

      var currentPage = 0;
      var autoplayTimer = null;
      var userStopped = false;
      var isMobile = function () { return window.innerWidth <= 699; };
      var perView = function () { return isMobile() ? 2 : 6; };
      var pageCount = function () { return Math.max(1, Math.ceil(slides.length / perView())); };
      var maxIndex = function () { return Math.max(0, slides.length - perView()); };
      var pageStartIndex = function (p) { return Math.min(p * perView(), maxIndex()); };

      function stepWidth() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);
        return slides[0].getBoundingClientRect().width + gap;
      }

      function buildDots() {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pageCount(); i++) {
          (function (idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'fbfcv3__dot' + (idx === currentPage ? ' is-active' : '');
            btn.setAttribute('aria-label', 'Go to page ' + (idx + 1));
            btn.addEventListener('click', function () { haltByUser(); currentPage = idx; updateSlider(); });
            dotsWrap.appendChild(btn);
          })(i);
        }
      }

      function updateDots() {
        dotsWrap.querySelectorAll('.fbfcv3__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === currentPage); });
      }

      function updateSlider(animate) {
        if (animate === undefined) animate = true;
        currentPage = Math.max(0, Math.min(currentPage, pageCount() - 1));
        var idx = pageStartIndex(currentPage);
        track.style.transition = animate ? 'transform 0.45s ease' : 'none';
        track.style.transform = 'translate3d(-' + (stepWidth() * idx) + 'px,0,0)';
        if (prevBtn) prevBtn.style.opacity = currentPage <= 0 ? '.4' : '1';
        if (nextBtn) nextBtn.style.opacity = currentPage >= pageCount() - 1 ? '.4' : '1';
        updateDots();
      }

      var nextPage = function (loop) { if (currentPage >= pageCount() - 1) { if (loop) { currentPage = 0; } } else { currentPage++; } updateSlider(); };
      var prevPage = function () { if (currentPage > 0) { currentPage--; } updateSlider(); };

      function startAutoplay() { if (!wantsAutoplay || userStopped) return; stopAutoplay(); autoplayTimer = setInterval(function () { nextPage(true); }, autoplaySpeed); }
      function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
      function haltByUser() { userStopped = true; stopAutoplay(); }

      if (wantsAutoplay && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { (entry.isIntersecting && !userStopped) ? startAutoplay() : stopAutoplay(); }); }, { threshold: 0.2 });
        io.observe(section);
      } else if (wantsAutoplay) { startAutoplay(); }

      section.addEventListener('mouseenter', haltByUser);
      if (nextBtn) nextBtn.addEventListener('click', function () { haltByUser(); nextPage(false); });
      if (prevBtn) prevBtn.addEventListener('click', function () { haltByUser(); prevPage(); });

      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; haltByUser(); }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { diff > 0 ? nextPage(false) : prevPage(); }
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { buildDots(); updateSlider(false); }, 120); });

      buildDots();
      updateSlider(false);
    }

    function initAll() {
      document.querySelectorAll('.fbfcv3').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-find-your-match"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var POOLS = {
      her: {
        clitoral: [["romeo-clitoral-suction-stimulator","B"],["egg-vibrator-2-types-strong-vibrating-egg-sex-toys-adult-toy-women-g-spot-clitoris-stimulation-ladies-vibrators-jump-egg","B"],["poutperfect-licker-flicking-sucking-8-modes-usb-rechargeable-adult-female-sex-toys-clitoris-stimulator","M"],["riose-2-in-1-clitoris-stimulator","M"],["sarah-succulent-2-in-1","M"],["osuga-cuddly-bird-classic-clitoral-suction-vibrator-bedside-lamp-official-distributor-singapore","M"],["cherry-lip-2-in-1-sucking-and-licking-vibrator","M"],["osuga-bubble-clitoral-suction-vibrator","M"],["womanizer-liberty-lilac","P"],["womanizer-starlet-3-indigo","P"],["osuga-kiss-heated-oral-vibrator","P"],["osuga-cuddly-bird-pro-clitoral-suction-vibrator-bedside-lamp-official-distributor-singapore","P"]],
        gspot: [["explorer-av-vibrator","B"],["supernova-powerful-wand-vibratior","B"],["euphoria-powerful-triple-vibrator","M"],["luna-retractable-vibrator","M"],["beckie-app-control-wearable-fingering-g-spot-vibrator","M"],["luvia-automatic-thrusting-vibrating-suction-3-in-1-vibrator","M"],["power-bloom-g-spot-vibrator","M"],["king-thrusting-vibrator","P"],["lovense-nora-app","P"],["womanizer-og-lilac","P"],["lovense-gravity","P"]],
        anal: [["silicone-butt-plug","B"],["stainless-steel-butt-plug","B"],["butt-plugs-small-to-huge","B"],["silicone-hollow-anal-plug-vaginal-peep-anal-dilator-douches-enema","B"],["smooth-black-dildo","B"],["sexy-fox-tail-butt-plug","B"],["heartray-app-control-anal-baton-vibrator-with-suction-base","M"],["captain-series-carlisle-realistic-liquid-silicone-dildo-suction-cup","M"],["lovense-lush-anal-app-controlled-anal-plug","P"],["lovense-hush-2","P"]]
      },
      him: {
        strokers: [["kawai-male-masturbators-5-types-men-fleshlight-masturbation-sex-toys-man-adult-doll-sexy-erotic-toy-aircraft-masturbator","B"],["peach-sisters-male-realistic-masturbator","B"],["flipside-fantasy-soft-tpe-masturbator","B"],["dual-pleasure-manual-male-masturbator-dildo","M"],["bomb-max-pocket-size-adult-male-masturbator","M"],["miss-yogini-small-torso-sex-doll-masturbator","M"],["suck-o-matic-automatic-sucking-masturbator","M"],["naomi-realistic-torso-masturbator","P"],["lovense-gush","P"],["lovense-max-2","P"]],
        rings: [["stay-hard-beaded-cock-ring","B"],["adam-vibrating-cock-ring","B"],["feisty-rabbit-vibrating-cock-ring-man-penis-rings-adult-toy-male-men-harder-erection-enlargement-sex-toys-sexy-vibrator","B"],["intima-lock-vibrating-cock-ring","B"],["thunder-dual-rechargeable-vibrating-cock-ring-strong-10-modes-vibration-male-adult-sex-toys","B"],["venom-touch-app-control-anal-vibrator-duo-loop-cock-ring","M"],["ace-vibrating-cock-ring","M"],["typhoon-dual-action-double-cock-ring","M"],["bionic-vibrating-cock-ring-10-modes-vibration-prolong-erection-clitoral-stimulation-testicle-vibrator-quality-silicone","M"],["playful-tongue-vibrating-double-cock-ring-man-penis-rings-adult-toy-male-sleeve-men-harder-erection-enlargement-sex-toys","M"],["titan-vibrating-penis-cock-ring-for-men-powerful-10-modes-vibration-couple-sex-toys-clit-stimulator-usb-rechargeable","M"],["tingle-tongue-tango-vibrating-tapping-cock-ring","M"]],
        prostate: [["silicone-butt-plug","B"],["stainless-steel-butt-plug","B"],["butt-plugs-small-to-huge","B"],["tushy-tingle-prostate-massager-with-triple-motors","M"],["vibe-voyager-vibrating-prostate-massager","M"],["noah-prostate-massager","M"],["lovense-hush-2","P"],["lovense-edge-2","P"]]
      },
      couples: {
        vv: [["vibrating-strap-on-dildo","B"],["black-strap-on-dildo","B"],["naughty-knob-harness-strap-on-dildo-adult-men-ladies-realistic-sex-toys","B"],["solo-sculpt-shorts-integrated-dildo-shorts","B"],["realistic-strap-on-dildo","M"],["bdsm-strap-on-3-dildos-harness-strap-on-kit","M"],["nightfall-nuzzler-strap-on-tapping-dildo","M"],["fleshion-series-realistic-silicone-strap-on-dildo-pants","M"],["joy-rider-strap-on-hollow-dildo","M"],["naughty-knickers-realistic-silicone-dildo-pants","M"],["mr-ben-bendable-dildo-vibrator","P"],["lovense-lapis","P"]],
        vp: [["stay-hard-beaded-cock-ring","B"],["bunny-wearable-stealth-vibrator-10-modes-female-outdoor-bedroom-g-spot-clitoris-stimulation-women-sex-toys-adult-toy","B"],["jess-mini-wearable-lipstick-vibrator-10-modes-vibration-usb-remote-control-indoor-outdoor-fun-velvety-body-safe-silicone","B"],["chloe-perfectly-curved-to-hold-in-the-palm-of-your-hand-vibrator-adult-female-sex-toys","B"],["bionic-vibrating-cock-ring-10-modes-vibration-prolong-erection-clitoral-stimulation-testicle-vibrator-quality-silicone","M"],["lina-dual-stimulator-suction-vibration-adult-female-vibrator-sex-toy","M"],["titan-vibrating-penis-cock-ring-for-men-powerful-10-modes-vibration-couple-sex-toys-clit-stimulator-usb-rechargeable","M"],["synthetic-wave-app-control-multi-play-wearable-vibrator","M"],["minna-muse-remote-control-wearable-vibrator","M"],["velvettouch-harmony-g-spot-and-clitoral-egg-vibrator","M"],["lovense-ferri","P"],["wevibe-sync-2-purple","P"]],
        pp: [["prostate-massager","B"],["double-trouble-steel-anal-plug","B"],["lucky-leaf-silicone-prostate-anal-stimulator-with-app-control","B"],["blaze-vibrating-anal-beads","B"],["bruno-retractable-vibrating-prostate-massager","M"],["squiggle-mate-squirming-prostate-massager","M"],["ace-remote-control-vibrating-silicone-anal-beads","M"],["tushy-tingle-prostate-massager-with-triple-motors","M"],["black-panther-prostate-massager","M"],["noah-prostate-massager","M"],["lovense-edge-2","P"],["lovense-max-2","P"]]
      }
    };
    var HEADS = {
      her: "Beautifully matched, just for her.",
      him: "Built for him.",
      couples: "Made to enjoy together."
    };

    document.querySelectorAll('[data-fbq2]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var ans = { aud: '', stim: '', budget: '' };
      var cache = {};
      var deck = [];      // shuffled eligible product handles for current result
      var cursor = 0;
      var screens = {};
      root.querySelectorAll('[data-screen]').forEach(function (s) { screens[s.getAttribute('data-screen')] = s; });
      var progress = root.querySelector('[data-progress]');
      var bar = root.querySelector('[data-progress-bar]');

      function show(name, step) {
        Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
        if (progress) { progress.hidden = (name === 'intro' || name === 'results'); }
        if (bar && step) { bar.style.width = (step * 33.3) + '%'; }
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }

      var startBtn = root.querySelector('[data-start]');
      if (startBtn) startBtn.addEventListener('click', function () { show('q1', 1); });

      root.querySelectorAll('.fbq2__opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var q = opt.getAttribute('data-q');
          var v = opt.getAttribute('data-val');
          ans[q] = v;
          if (q === 'aud') { show('q2-' + v, 2); }
          else if (q === 'stim') { show('q3', 3); }
          else if (q === 'budget') { finish(); }
        });
      });

      root.querySelectorAll('[data-back]').forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-back');
          if (t === 'q1') show('q1', 1);
          else if (t === 'q2') show('q2-' + ans.aud, 2);
        });
      });

      function eligible() {
        var group = POOLS[ans.aud] || {};
        var list = [];
        if (ans.stim === 'all') {
          Object.keys(group).forEach(function (k) { list = list.concat(group[k]); });
        } else {
          list = (group[ans.stim] || []).slice();
        }
        // de-dupe by handle (keep first band seen)
        var seen = {}, uniq = [];
        list.forEach(function (x) { if (!seen[x[0]]) { seen[x[0]] = 1; uniq.push(x); } });
        if (ans.budget === 'all') { return shuffle(uniq.map(function (x) { return x[0]; })); }
        // chosen band first, then the rest as graceful fallback (so a thin tier is never empty)
        var inBand = shuffle(uniq.filter(function (x) { return x[1] === ans.budget; }).map(function (x) { return x[0]; }));
        var rest = shuffle(uniq.filter(function (x) { return x[1] !== ans.budget; }).map(function (x) { return x[0]; }));
        return inBand.concat(rest);
      }

      function shuffle(a) {
        for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
        return a;
      }

      function fetchProduct(handle) {
        if (cache[handle]) return Promise.resolve(cache[handle]);
        return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { cache[handle] = p; return p; })
          .catch(function () { return null; });
      }

      function money(cents) {
        var v = (cents / 100);
        return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
      }

      function card(p) {
        var a = document.createElement('a');
        a.className = 'fbq2__card';
        a.href = p.url;
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; a.innerHTML = '<img src="' + img + '&width=300" loading="lazy" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">'; }
        a.innerHTML += '<span class="fbq2__card-t">' + (p.title || '') + '</span><span class="fbq2__card-p">' + money(p.price) + '</span>';
        return a;
      }

      var grid = root.querySelector('[data-grid]');
      var emptyMsg = root.querySelector('[data-empty]');
      var moreBtn = root.querySelector('[data-more]');

      function renderNext() {
        if (!deck.length) { grid.innerHTML = ''; if (emptyMsg) emptyMsg.hidden = false; if (moreBtn) moreBtn.hidden = true; return; }
        if (emptyMsg) emptyMsg.hidden = true;
        grid.innerHTML = '<div class="fbq2__loading"><span class="fbq2__spinner" aria-hidden="true"></span>Looking for your match&hellip;</div>';
        var want = Math.min(4, deck.length);
        var picks = [];
        var attempts = 0;
        (function fill() {
          if (picks.length >= want || attempts >= deck.length) { paint(); return; }
          if (cursor >= deck.length) { cursor = 0; shuffle(deck); }
          var h = deck[cursor++]; attempts++;
          fetchProduct(h).then(function (p) {
            if (p && p.available && picks.indexOf(p) < 0) picks.push(p);
            fill();
          });
        })();
        function paint() {
          grid.innerHTML = '';
          if (!picks.length) { if (emptyMsg) emptyMsg.hidden = false; if (moreBtn) moreBtn.hidden = true; return; }
          picks.forEach(function (p) { grid.appendChild(card(p)); });
          if (moreBtn) moreBtn.hidden = (deck.length <= picks.length);
        }
      }

      function finish() {
        deck = eligible();
        cursor = 0;
        var head = root.querySelector('[data-head]');
        var sub = root.querySelector('[data-subline]');
        if (head) head.textContent = HEADS[ans.aud] || "Here's where we'd start you.";
        if (sub) {
          var b = ans.budget === 'B' ? 'budget-friendly' : ans.budget === 'M' ? 'mid-range' : ans.budget === 'P' ? 'premium' : 'hand-picked';
          sub.innerHTML = 'Your ' + b + ' picks — matched to your answers, accessories left out.';
        }
        var shop = root.querySelector('[data-shoplink]');
        if (shop) { shop.setAttribute('href', linkFor()); }
        show('results');
        renderNext();
      }

      function linkFor() {
        var map = {
          her: { clitoral: '/collections/clitoral-suction-vibrators', gspot: '/collections/vibrators', anal: '/collections/anal-toys-singapore', all: '/collections/sex-toys-for-her-singapore' },
          him: { strokers: '/collections/sex-toys-for-him-singapore', rings: '/collections/sex-toys-for-him-singapore', prostate: '/collections/anal-toys-singapore', all: '/collections/sex-toys-for-him-singapore' },
          couples: { vv: '/collections/couple-vibrators', vp: '/collections/couple-vibrators', pp: '/collections/couple-vibrators', all: '/collections/couple-vibrators' }
        };
        return (map[ans.aud] && map[ans.aud][ans.stim]) || '/collections/sex-toys-singapore';
      }

      if (moreBtn) moreBtn.addEventListener('click', renderNext);

      var restart = root.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', function () { ans = { aud: '', stim: '', budget: '' }; show('intro'); });

      // copy the code to clipboard
      var copyBtn = root.querySelector('[data-reveal-copy]');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var codeEl = root.querySelector('[data-reveal-code]');
        var txt = codeEl ? (codeEl.textContent || '').trim() : '';
        if (!txt) return;
        var ok = function () { copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600); };
        var fallback = function () { try { var t = document.createElement('textarea'); t.value = txt; t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); ok(); } catch (e) {} };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(txt).then(ok).catch(fallback); } else { fallback(); }
      });

      // email step -> subscribe (fire & forget) + reveal the code instantly on-screen
      var form = root.querySelector('[data-form]');
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = root.querySelector('[data-msg]');
        var email = (form.querySelector('input[name=email]').value || '').trim();
        if (!email || email.indexOf('@') < 1) { if (msg) { msg.hidden = false; msg.textContent = 'Please enter a valid email.'; } return; }
        var key = root.getAttribute('data-klaviyo-key');
        var list = root.getAttribute('data-klaviyo-list');
        var code = root.getAttribute('data-discount') || '';
        // capture the email to the list (does not block the reveal)
        if (key && list) {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              custom_source: 'Find Your Match Quiz',
              profile: { data: { type: 'profile', attributes: { email: email, properties: { quiz_audience: ans.aud, quiz_stim: ans.stim, quiz_budget: ans.budget } } } }
            }, relationships: { list: { data: { type: 'list', id: list } } } } })
          }).catch(function () {});
        }
        // reveal the code immediately (auto-apply link -> matched collection)
        if (msg) msg.hidden = true;
        var pre = root.querySelector('[data-precapture]');
        if (pre) { pre.hidden = true; } else { form.hidden = true; }
        var cta = root.querySelector('[data-reveal-cta]');
        if (cta) cta.setAttribute('href', linkFor()); // manual code -> plain link, buyer enters code at checkout
        var reveal = root.querySelector('[data-reveal]');
        if (reveal) reveal.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
